// DailySalaryCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Gaji Harian - Hitung Upah Harian dari Gaji Bulanan";
const DESCRIPTION =
  "Hitung gaji harian Anda berdasarkan gaji bulanan Anda dan jumlah hari kerja dalam sebulan. Kalkulator ini menyediakan cara mudah dan cepat untuk mengetahui berapa penghasilan Anda per hari.";
const KEYWORDS = "kalkulator, gaji, upah, harian, kerja, hitung, bulanan";
const OG_URL =
  "https://do-calculate.com/calculator/id/daily-salary-calculator/";
function DailySalaryCalculator() {
  const [monthlySalary, setMonthlySalary] = useState("0");
  const [workDaysPerMonth, setWorkDaysPerMonth] = useState("0");
  const [dailyRate, setDailyRate] = useState(null);
  const [error, setError] = useState("");
  const calculateDailyRate = () => {
    try {
      if (monthlySalary === "0" && workDaysPerMonth === "0") {
        setError("Harap masukkan gaji dan jumlah hari kerja yang valid untuk menghitung gaji harian");
        return;
      }
      const dailyWage = monthlySalary / workDaysPerMonth;
      setDailyRate(dailyWage);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
                    <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menyediakan cara mudah untuk mengetahui gaji yang Anda peroleh per hari berdasarkan gaji bulanan Anda dan jumlah hari kerja dalam sebulan. Mengetahui gaji harian penting untuk lebih memahami nilai hari kerja Anda, baik Anda sedang mempertimbangkan negosiasi gaji atau merencanakan pekerjaan tambahan. Kalkulator ini berguna bagi orang-orang yang bekerja dengan gaji bulanan dan ingin mengetahui bagaimana pendapatan mereka terdistribusi pada hari-hari kerja dalam sebulan.
                </p>
                <p>
                  Misalnya, jika Anda menerima gaji bulanan sebesar 6000 dan bekerja 22 hari dalam sebulan, Anda dapat menggunakan kalkulator ini untuk menentukan berapa penghasilan Anda per hari. Mengetahui detail ini dapat membantu Anda membuat keputusan keuangan yang lebih bijak dan dalam negosiasi upah yang lebih baik berdasarkan nilai waktu Anda yang sebenarnya.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="salary">Gaji Bulanan:</label>
                    <input
                      id="salary"
                      type="number"
                      value={monthlySalary}
                      onChange={(e) => setMonthlySalary(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="work-days">Jumlah Hari Kerja dalam Sebulan:</label>
                    <input
                      id="work-days"
                      type="number"
                      value={workDaysPerMonth}
                      onChange={(e) => setWorkDaysPerMonth(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateDailyRate}
                  >
                    Hitung
                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">Error: {error}</p>
                ) : (
                  dailyRate !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>Gaji Harian: {dailyRate.toFixed(2)}</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Cara Menghitung Gaji Harian</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 1: Menentukan Gaji Bulanan
                    </h2>
                  </u>
                  <p>
                    Pertama, Anda perlu mengetahui gaji bulanan yang Anda terima. Ini harus mencakup semua tunjangan dan kompensasi yang Anda terima setiap bulan. Memasukkan gaji bulanan dengan akurat adalah langkah pertama menuju perhitungan gaji harian yang benar. Ingat bahwa gaji bulanan adalah dasar yang akan Anda gunakan untuk perhitungan selanjutnya.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 2: Menentukan Jumlah Hari Kerja dalam Sebulan
                    </h2>
                  </u>
                  <p>
                    Setelah menentukan gaji bulanan, Anda harus memasukkan jumlah hari kerja dalam sebulan. Angka ini mewakili hari-hari Anda bekerja selama sebulan di mana Anda menerima gaji. Jumlah hari kerja dapat bervariasi dari bulan ke bulan, tetapi sebaiknya masukkan jumlah rata-rata hari yang Anda kerjakan setiap bulan. Informasi ini penting untuk menghitung gaji harian secara akurat.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 3: Menghitung Gaji Harian
                    </h2>
                  </u>
                  <p>
                    Setelah memasukkan gaji bulanan dan jumlah hari kerja dalam sebulan, Anda sekarang dapat menghitung gaji harian. Untuk melakukannya, bagi gaji bulanan dengan jumlah hari kerja dalam sebulan untuk mendapatkan gaji harian. Perhitungan ini akan memberikan nilai yang tepat untuk gaji yang Anda peroleh per hari.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: Jika gaji bulanan Anda 6000 dan jumlah hari kerja dalam sebulan 22 hari, maka gaji harian akan sekitar 272.73.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 4: Menggunakan Gaji Harian dalam Perencanaan Keuangan
                    </h2>
                  </u>
                  <p>
                    Setelah mengetahui gaji harian, Anda dapat menggunakan informasi ini dalam perencanaan keuangan Anda. Misalnya, jika Anda mempertimbangkan untuk bekerja hari tambahan atau perlu mengetahui apakah gaji harian Anda cukup untuk menutupi pengeluaran Anda, mengetahui gaji harian membantu Anda membuat keputusan yang tepat. Perhitungan ini juga dapat membantu Anda dalam negosiasi gaji yang lebih baik berdasarkan nilai hari kerja Anda.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: Jika Anda berencana bekerja 5 hari tambahan dalam sebulan, Anda dapat menghitung jumlah gaji tambahan yang akan Anda peroleh berdasarkan gaji harian.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default DailySalaryCalculator;